
import {mean, variance, extent, range, quantile} from 'd3'

export const mustIgnoreValue = (value:number|undefined|null,onlyPositive:boolean = false) => {
  return value == 9999 || value == -9999 || value === null || value === undefined || (onlyPositive && value <= 0) || value === Infinity || value === -Infinity || Number.isNaN(value)
}

//retourne un domaine 
export const autoScaleDomain3 = (values:Array<any>, accessor:(x:any) => any = x => x, logAxis:boolean = false) => {
  //const dataValues = (accessor?values.map(accessor):values).sort((a, b) => (a > b) ? 1 : -1)
  //const filteredValue = (values[0].hasOwnProperty('NAV_DEPTH')?values.filter(f => f.NAV_DEPTH > 3):values).map(accessor)      
  const filteredValue = values.map(accessor) 
  const dataFilteredValues = filteredValue.filter(v => !mustIgnoreValue(v,logAxis)).sort((a, b) => (a > b) ? 1 : -1)  
  let domain = [quantile(dataFilteredValues,0.02)! ,quantile(dataFilteredValues,logAxis?0.95:0.90)!]    
  if(domain[0] == domain[1]) domain = [quantile(dataFilteredValues,0.01)! ,quantile(dataFilteredValues,logAxis?0.97:0.95)!]    
  if(domain[0] == domain[1]) domain = [quantile(dataFilteredValues,0)! ,quantile(dataFilteredValues,1)!]      
  return [domain[0], (domain[1]+domain[0])/2 , domain[1]]  
}

export const autoScaleDomain = (values:Array<any>, accessor:(x:any) => any = x => x, logAxis:boolean = false) => {
  //const dataValues = (accessor?values.map(accessor):values).sort((a, b) => (a > b) ? 1 : -1)  
  //const filteredValue = (values[0].hasOwnProperty('NAV_DEPTH')?values.filter(f => f.NAV_DEPTH > 3):values).map(accessor)      
  const filteredValue = values.map(accessor) 
  const dataFilteredValues = filteredValue.filter(v => !mustIgnoreValue(v,logAxis)).sort((a, b) => (a > b) ? 1 : -1)  
  if(logAxis) return  [quantile(dataFilteredValues,0.02)!  ,quantile(dataFilteredValues,0.98)!]
  const ecartType = 2 * Math.sqrt(variance(dataFilteredValues)!)    
  return [quantile(dataFilteredValues,0.02)! - ecartType  ,quantile(dataFilteredValues,0.98)! + ecartType]
}

export const chartColor = [
  '#3366cc',
'#dc3912',
'#ff9900',
'#109618',
'#990099',
'#0099c6',
'#dd4477',
'#66aa00',
'#b82e2e',
'#316395',
'#994499',
'#22aa99',
'#aaaa11',
'#6633cc',
'#e67300',
'#8b0707',
'#651067',
'#329262',
'#5574a6',
'#3b3eac',
'#b77322',
'#16d620',
'#b91383',
'#f4359e',
'#9c5935',
'#a9c413',
'#2a778d',
'#668d1c',
'#bea413',
'#0c5922',
'#743411'
]

/*export const autoScaleDomain3 = (values:Array<any>, accessor?:(x:any) => any) => {
  const dataValues = accessor?values.map(accessor):values
  const extentArr = extent(dataValues)
  const meanVal = mean(dataValues)  
  const ecartType = 3 * Math.sqrt(variance(dataValues)!)    
  const domain = [Math.max(meanVal!-ecartType,extentArr[0]) , Math.min(meanVal!+ecartType,extentArr[1])]  
  return [domain[0], (domain[1]+domain[0])/2 , domain[1]]  
}*/




/*export const autoScaleLinearLegendValue = (domain3, nbpointInterPerPart) => {  
  const ecart1 = (domain3[1] - domain3[0]) / parseFloat(nbpointInterPerPart + 1)
  const ecart2 = (domain3[2] - domain3[1]) / parseFloat(nbpointInterPerPart + 1)
  const datas = []
  const part1 = range(nbpointInterPerPart).map(d => {
    return (d+1) * ecart1 + domain3[0]
  })
  const part2 = range(nbpointInterPerPart).map(d => {
    return (d+1) * ecart2 + domain3[1]
  })
  return [domain3[0],...part1,domain3[1],...part2,domain3[2]]
}*/